module.exports = __webpack_public_path__ + "img/story-back.33aec2ea.jpg";